import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Replace any image that fails to load (e.g. an external host going down) with a branded placeholder.
const FALLBACK_IMG = "data:image/svg+xml;utf8," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#EFE7DA"/><circle cx="300" cy="270" r="70" fill="none" stroke="#4F8176" stroke-width="6"/><path d="M300 200a35 35 0 0 1 0 70a35 35 0 0 0 0 70" fill="none" stroke="#4F8176" stroke-width="6"/><text x="300" y="420" text-anchor="middle" font-family="Georgia,serif" font-size="34" fill="#2B3530">Isoharts</text></svg>'
);
document.addEventListener("error", (e) => {
  const el = e.target;
  if (el && el.tagName === "IMG" && el.src !== FALLBACK_IMG) {
    el.src = FALLBACK_IMG;
    el.style.objectFit = "cover";
  }
}, true);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
